import { render, staticRenderFns } from "./ShowDissolutionNGO.vue?vue&type=template&id=2708377e&"
import script from "./ShowDissolutionNGO.vue?vue&type=script&lang=js&"
export * from "./ShowDissolutionNGO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports